// import createPersistedState from 'vuex-persistedstate'

const login = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    // 遷移先URI
    destinationURI: '',
    // タイムアウト時にログイン画面に遷移した時にNotice表示する判定フラグ
    isTimeoutMessageShown: false
  },
  getters: {
  },
  mutations: {
    setDestinationURI(state, destinationURI) {
      state.destinationURI = destinationURI
    },
    setIsTimeoutMessageShown(state, isTimeoutMessageShown) {
      state.isTimeoutMessageShown = isTimeoutMessageShown
    }
  },
  actions: {
    /**
     * 遷移先URIを保持
     */
    setDestinationURI({ commit }, destinationURI) {
      commit('setDestinationURI', destinationURI)
    },
    /**
     * ログイン画面に強制遷移した時にタイムアウトのNoticeを表示
     */
    setIsTimeoutMessageShown({ commit }, isTimeoutMessageShown) {
      commit('setIsTimeoutMessageShown', isTimeoutMessageShown)
    }
  }
}

export default login
